// useReleaseCandidate - laedt den Release-Kandidaten fuer den Space und
// erlaubt einen PROD-Release. Endpoints:
//   GET  /api/cicd/release-candidate?spaceId=...
//   POST /api/cicd/transport/release  (Feldname approvalNote!)

import { useCallback, useEffect, useState } from "react";
import { api } from "../../../utils/helpers";

export function useReleaseCandidate(spaceId, enabled) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [releasing, setReleasing] = useState(false);
  const [releaseError, setReleaseError] = useState(null);

  const reload = useCallback(async () => {
    if (!enabled || !spaceId) { setData(null); return; }
    setLoading(true);
    setError(null);
    try {
      const r = await api(`/api/cicd/release-candidate?spaceId=${encodeURIComponent(spaceId)}`);
      setData(r || null);
    } catch (e) {
      setError(e?.message || "Release-Kandidat nicht verfuegbar");
    }
    setLoading(false);
  }, [spaceId, enabled]);

  useEffect(() => { reload(); }, [reload]);

  const releaseNow = useCallback(async ({ approvalNote, extra }) => {
    if (!spaceId) return;
    setReleasing(true);
    setReleaseError(null);
    try {
      await api("/api/cicd/transport/release", {
        method: "POST",
        timeout: 120000,
        body: JSON.stringify({ spaceId, approvalNote, language: localStorage.getItem("iio-lang") === "en" ? "en" : "de", ...(extra || {}) }),
      });
      // nachladen um "kein Release-Kandidat mehr offen" zu zeigen
      await reload();
      setReleasing(false);
      return true;
    } catch (e) {
      setReleaseError(e?.message || "Release fehlgeschlagen");
      setReleasing(false);
      throw e;
    }
  }, [spaceId, reload]);

  return { data, loading, error, releasing, releaseError, reload, releaseNow };
}
